import React, { useMemo } from 'react'
import { LoyaltyPointsEarningConfiguration } from './CartReviewTile'
import LoyaltyPointsEarnWithBreakdownModal from 'loyalty/components/Earn/LoyaltyPointsEarnWithBreakdownModal'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import { getMerchandiseVariantOptionText } from 'components/Merchandise/merchandiseUtils'

interface Props {
  brand: string;
  title: string;
  variant?: App.MerchandiseOfferVariant;
  loyaltyPointsEarningConfiguration?: LoyaltyPointsEarningConfiguration;
}

function MerchandiseCartReviewTileContent(props: Props) {
  const { brand, title, variant, loyaltyPointsEarningConfiguration } = props
  const variantDetails = useMemo(() => {
    if (variant) {
      return getMerchandiseVariantOptionText(variant)
    }
  }, [variant])

  return <VerticalSpacer gap={12}>
    <VerticalSpacer gap={2}>
      <BodyText variant="medium" colour="neutral-two">{brand}</BodyText>
      <Heading variant="heading6">{title}</Heading>
      {variantDetails && <BodyText variant="medium" colour="neutral-two">{variantDetails}</BodyText>}
    </VerticalSpacer>
    {loyaltyPointsEarningConfiguration &&
      <LoyaltyPointsEarnWithBreakdownModal
        calculationRequests={loyaltyPointsEarningConfiguration.calculationRequests}
        calculationType={loyaltyPointsEarningConfiguration.calculationType}
        hideStatusCredits={loyaltyPointsEarningConfiguration.hideStatusCredits}
      />}
  </VerticalSpacer>
}

export default React.memo(MerchandiseCartReviewTileContent)
